import EmiCalculator from '../components/EmiCalculator';
import { defineCalculator } from './defineCalculator';

defineCalculator('scl-emi-calculator', EmiCalculator);
